import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import SearchResults from './pages/SearchResults';
import HomePage from './pages/Home';
import YachtDetails from './pages/YachtDetails';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import PartnerLogin from './pages/PartnerLogin';
import PartnerDashboard from './pages/PartnerDashboard';
import TransferForm from './pages/TransferPage';
import FloatingSocialMenu from './components/SocialMediaButton/FloatingSocialMenu';
const App = () => {
  return (
    <>
    
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/yachts" element={<SearchResults />} />
        <Route path="/yachts/:id" element={<YachtDetails />} />
        <Route path="/cruises" element={<TransferForm />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/partner/login" element={<PartnerLogin />} />
        <Route path="/partner/dashboard" element={<PartnerDashboard />} />
      </Routes>
    </BrowserRouter>
    <FloatingSocialMenu />
    </>
  );
};

export default App;
